import { DateTime } from 'luxon';

export default function isBeforeDay(a, b) {
    if (!DateTime.isDateTime(a) || !DateTime.isDateTime(b)) return false;

    const normalizedA = a.set({
        hour: 12,
        minute: 0,
        second: 0,
        millisecond: 0,
    });
    const normalizedB = b.set({
        hour: 12,
        minute: 0,
        second: 0,
        millisecond: 0,
    });

    return normalizedA.toMillis() < normalizedB.toMillis();
}
